<template>
  <div :id="'accordion'">
    <div class="card">
      <div class="card-header" id="'headingOne'">
        <h5 class="mb-0">
          <button
            class="btn btn-link"
            data-toggle="collapse"
            :data-target="'#collapseOne'"
            aria-expanded="true"
            :aria-controls="'collapseOne'"
          >
            Radni nalog za {{ getExecuteData.customer }}
          </button>
        </h5>
      </div>

      <div
        :id="'collapseOne'"
        class="collapse show"
        :aria-labelledby="'headingOne'"
        :data-parent="'#accordion'"
      >
        <div class="card-body">
          <ul class="list-group">
            <li class="list-group-item">
              Klijent : {{ getExecuteData.customer }}
            </li>
            <li class="list-group-item">{{ getExecuteData.typeOfProblem }}</li>
            <li class="list-group-item">
              Tiket otvoren : {{ getExecuteData.dateTicketWasOpened }}
            </li>
            <li class="list-group-item">
              Kontakt osoba: {{ getExecuteData.contactPerson }}
            </li>
            <li class="list-group-item">
              Broj telefona : {{ getExecuteData.phoneNumber }}
            </li>
            <li class="list-group-item">
              Opis : {{ getExecuteData.problemDescription }}
            </li>
          </ul>
        </div>
        <v-row no-gutters v-if="tasks.length > 0">
          <v-data-table :headers="headers" :items="tasks" class="elevation-1">
            <template v-slot:item.date="{ item }">
              <span>{{
                typeof item.date === "number"
                  ? new Date(item.date)
                  : new Date(item.date.seconds * 1000) | moment
              }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn text small color="primary" @click="editTask(item)"
                >Edit</v-btn
              >
              <v-btn text small color="error" @click="deleteTask(item)"
                >Delete</v-btn
              >
            </template>
          </v-data-table>
        </v-row>
        <task-form v-on:newTask="addNewTask" />
      </div>
    </div>

    <div class="form-check mt-2 mb-2">
      <input
        type="checkbox"
        class="form-check-input"
        id="usedMaterials"
        v-model="usedMaterial"
      />
      <label class="form-check-label" for="usedMaterials"
        >Da li je koristen potrosni materijal</label
      >
      <v-row v-if="usedMaterial">
        <div class="col-md-6">
          <UsedMaterials v-on:newMaterial="newMaterials" />
        </div>
        <div class="col-md-6">
          <ul class="list-group" v-if="materials && materials.length">
            <h3>Izabrani materijali</h3>
            <li
              class="list-group-item"
              v-for="(item, index) in materials"
              :key="index"
            >
              {{ index + 1 }}. {{ item.materialName }} - {{ item.value }}
              {{ item.unit }}
              <button type="button" class="btn btn-link" @click="editMat(item)">
                Edit
              </button>
              <button
                type="button"
                class="btn btn-link"
                @click="removeMat(index)"
              >
                Delete
              </button>
            </li>
          </ul>
          <button
            class="btn btn-link"
            @click="saveMaterials"
            v-if="materials.length > 0"
          >
            Sacuvaj
          </button>
        </div>
      </v-row>
      <v-row class="mt-5">
        <button
          class="btn btn-success"
          :disabled="
            tasks.length === 0 || (usedMaterial && materials.length === 0)
          "
          @click="updateWorklog"
        >
          Sacuvaj
        </button>
        <button
          class="btn btn-primary ml-2"
          :disabled="
            tasks.length === 0 || (usedMaterial && materials.length === 0)
          "
          @click="closeWorklog"
        >
          Zakljuci
        </button>
      </v-row>
    </div>
  </div>
</template>
<script>
import TaskForm from "@/components/Worklog/TaskForm";
import UsedMaterials from "@/components/Worklog/UsedMaterials";
import EventBus from "@/eventBus";
import moment from "moment";
/*eslint-disable*/
export default {
  mounted() {
    if (this.getExecuteData && this.getExecuteData.taskInProgress) {
      this.tasks =
        this.getExecuteData.tasks.length > 0 ? this.getExecuteData.tasks : [];
      this.materials =
        this.getExecuteData.materials.length > 0
          ? this.getExecuteData.materials
          : [];
      this.usedMaterial =
        this.getExecuteData.materials.length > 0 ? true : false;
    }
  },
  data() {
    return {
      tasks: [],
      count: 0,
      editMode: false,
      usedMaterial: false,
      materials: [],
      headers: [
        { text: "Izvodjac", value: "person" },
        { text: "date", value: "date" },
        { text: "location", value: "location" },
        { text: "workTimeSpent", value: "workTimeSpent" },
        { text: "workTime", value: "workTime" },
        { text: "workTimeUnit", value: "workTimeUnit" },
        { text: "city", value: "city" },
        { text: "description", value: "description" },
        { text: "actions", value: "actions" }
      ]
    };
  },
  components: {
    "task-form": TaskForm,
    UsedMaterials
  },
  computed: {
    getExecuteData() {
      return this.$store.getters.getExecuteData;
    }
  },
  methods: {
    addNewTask(task) {
      var element = {};
      var id = 0;
      var exists = false;
      this.tasks.forEach((item, index) => {
        if (item.id === task.id) {
          this.$set(this.tasks, index, task);
          exists = true;
        }
      });
      if (!exists) this.tasks.push(task);
    },
    deleteTask(item) {
      this.tasks = this.tasks.filter(e => e.id !== item.id);
    },
    newMaterials(val) {
      var element = {};
      var id = 0;
      var exists = false;
      this.materials.forEach((item, index) => {
        if (item.id === val.id) {
          this.$set(this.materials, index, val);
          exists = true;
        }
      });
      if (!exists) this.materials.push(val);
    },
    removeMat(val) {
      this.materials.splice(val, 1);
    },
    editMat(val) {
      EventBus.$emit("EDIT_MODE", val);
    },
    editTask(val) {
      EventBus.$emit("EDIT_TASK", val);
    },
    checkForMat(item) {
      var result = 0;
      this.materials.forEach((element, index) => {
        if (element.materialName === item.materialName) {
          result = index;
        }
      });
      return result;
    },
    saveMaterials() {
      this.$store.commit("addMaterials", this.materials);
    },
    updateWorklog() {
      this.getExecuteData.tasks = this.tasks;
      this.getExecuteData.materials = this.materials;
      this.getExecuteData.taskInProgress = true;

      this.$store.dispatch("saveChanges", this.getExecuteData);
    },
    closeWorklog() {
      this.getExecuteData.tasks = this.tasks;
      this.getExecuteData.materials = this.materials;
      this.getExecuteData.taskInProgress = true;
      this.getExecuteData.dateTicketWasClosed = Date.now();
      this.$store.dispatch("closeWorklog", this.getExecuteData);
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD-MM-YYYY HH:MM");
    }
  }
};
</script>
